module.exports = __webpack_public_path__ + "static/media/question.bc75fe67.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/question.png
// module id = 70
// module chunks = 6